module.exports = __webpack_public_path__ + "static/media/PBDQ_Style_Claymation.2fdc3107.png";